<template>
  <el-container>
    <!--左侧导航栏-->
    <el-aside style="width: 260px;">
      <div class="asideContainer">
        <div class="asideList">
          <router-link class="aCoverDiv" :to="{name: item.link}" v-for="(item, index) in plateList" :key="'plateList'+index">
            <div class="asideItem">
              <div class="titleIcon">
                <img :src="item.iconSrc" height="24px" />
              </div>
              <div class="titleText">
                {{item.name}}
              </div>
            </div>
          </router-link>
          <!--分隔线-->
          <div style="background-color: #617799;height: 0.05rem;"></div>
        </div>
      </div>
    </el-aside>
    <!--右侧内容，子路由跳转-->
    <el-main style="padding: 12px 12px 12px 0!important;overflow: visible;">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
import { selectApplystypeList } from '../../../api/appStore/appCommon'

export default {
  name: 'developerCenter',
  data () {
    return {
      // 左侧板块菜单
      plateList: [
        { name: '固件管理', iconSrc: require('@/assets/market/首页_u51.svg'), link: 'OTAHome' },
        { name: '产品管理', iconSrc: require('@/assets/market/商店_u61.svg'), link: 'product' }
        // { name: '应用软件发布', iconSrc: require('@/assets/market/u55.svg'), link: 'appPublish' },
        // { name: '订单信息', iconSrc: require('@/assets/market/u58.svg'), link: 'orderInfo' },
      ],
      // 左侧应用软件分类，动态获取
      plateAppList: [
        // { name: '设备监控', iconSrc: require('@/assets/market/选型_u13.svg'), link: '/market/sortApp/1' },
      ]
    }
  },
  methods: {
    // 动态获取左侧应用软件分类
    getPlateAppList () {
      selectApplystypeList().then(res => {
        if (res.returnCode === '100') {
          let dataArr = res.returnData
          let resArr = []
          for (let i = 0; i < dataArr.length; i++) {
            let item = {
              name: dataArr[i].applytypeName,
              iconSrc: require('@/assets/market/选型_u13.svg'),
              link: '/market/sortApp/' + dataArr[i].applytypeId
            }
            resArr.push(item)
          };
          this.plateAppList = resArr
        }
      }).catch(e => e)
    }
  },
  mounted () {
    this.getPlateAppList()
  }
}
</script>

<style scoped lang="less">
  .asideContainer {
    height: 100vh;
    padding: 0.5rem;
    .asideList {
      height: 100%;
      background-color: white;
      box-shadow: 4px 4px #f2f2f2;
      text-align: left;
    }
  }

  /*左侧菜单的选中样式*/
  .asideItem {
    height: 54px;
    line-height: 54px;
    cursor: pointer;
  }
  .asideItem:hover {
    background-color: #f0f0f0;
  }

  .titleIcon {
    margin: 0 28px;
    display: inline-block;
  }
  .titleText {
    display: inline-block;
    font-size: 18px;
    vertical-align: baseline;
    color: #617799;
  }
  /*确保整个可点击区域都能进行路由跳转*/
  .aCoverDiv {
    display: inline-block;
    width: 100%;
  }
  .router-link-active{
    .asideItem {
      background-color: #617799;
      .titleText {
        color: #FFFFFF;
      }
    }
    .asideItem:hover {
      background-color: #617799;
    }
  }
</style>
